import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { endsWith, keys, replace, trim } from 'lodash'
import Checkbox from '../../../../components/forms/Checkbox'
import Input from '../../../../components/forms/Input'
import Button from '../../../../components/forms/Button'
import RadioButtons from '../../../../components/forms/RadioButtons'
import Job from '../../../dto/DtoJob'
import { Grid } from '@mui/material'
import { iaeauUrl } from '../../../../conf/SieauConstants'
import { useChainBindings } from '../../utils/ImportUtils'

const IAEAU_ENV_PROD = 'prod'
const IAEAU_ENV_RECETTE = 'recette'
const IAEAU_ENV_AUTRE = 'autre'
const IAEAU_RECETTE_URL = 'https://recette.ia-eau.fr/#/'

const ProcessFileIAEauJob = ({
    filters,
    isEditMode,
    onChangeFilters,
}) => {
    const disabled = !isEditMode
    const accountUser = useSelector(store => store.AccountReducer.accountUser)
    const contacts = useSelector(store => store.ContactReducer.contacts)
    const userEmail = accountUser?.email || contacts?.find(c => c.id === accountUser?.contactCode)?.email || ''
    const isAquasysUser = userEmail.toLowerCase().includes('@aquasys.fr')

    const iaeauEnvElements = [
        { code: IAEAU_ENV_PROD, label: i18n.iaeauEnvProd },
        { code: IAEAU_ENV_RECETTE, label: i18n.iaeauEnvRecette },
        { code: IAEAU_ENV_AUTRE, label: i18n.iaeauEnvAutre },
    ]

    useEffect(() => {
        if (!keys(filters).length) {
            onChangeFilters({
                inputDir: 'DATA',
                outputDir: 'DATA',
                filter: '*.xlsx',
                iaeauEnv: IAEAU_ENV_PROD,
            })
        } else if (!filters.iaeauEnv) {
            onChangeFilters({ iaeauEnv: IAEAU_ENV_PROD })
        }
    }, [filters])
    useChainBindings(filters, onChangeFilters)

    const getBaseUrl = () => {
        if (filters.iaeauEnv === IAEAU_ENV_RECETTE) return IAEAU_RECETTE_URL
        if (filters.iaeauEnv === IAEAU_ENV_AUTRE && filters.customUrl) {
            const cleanUrl = replace(trim(filters.customUrl), /\/api\/?$/, '')
            const urlWithSlash = endsWith(cleanUrl, '/') ? cleanUrl : `${cleanUrl}/`
            return endsWith(urlWithSlash, '#/') ? urlWithSlash : `${urlWithSlash}#/`
        }
        return iaeauUrl
    }

    const baseUrl = getBaseUrl()
    const targetIAEauChainUrl = filters.chainId
        ? `${baseUrl}chains/chain/${filters.chainId}`
        : `${baseUrl}chains`

    return (
        <Grid container rowSpacing={1}>
            <Grid container sx={{ pt: 1 }} spacing={1} justifyContent='flex-start' alignItems='center'>
                <Grid size={12}>
                    <RadioButtons
                        title={i18n.iaeauEnv}
                        elements={iaeauEnvElements}
                        selected={filters.iaeauEnv || IAEAU_ENV_PROD}
                        onChange={value => onChangeFilters({ iaeauEnv: value })}
                        disabled={disabled}
                    />
                </Grid>
                {filters.iaeauEnv === IAEAU_ENV_AUTRE && (
                    <Grid size={8}>
                        <Input
                            title={i18n.iaeauCustomUrl}
                            value={filters.customUrl || ''}
                            onChange={value => onChangeFilters({ customUrl: value })}
                            disabled={disabled}
                        />
                    </Grid>
                )}
                <Grid size={4}><Input title={i18n.iaeauInputDir} value={filters.inputDir} onChange={v => onChangeFilters({ inputDir: v })} disabled={disabled} /></Grid>
                <Grid size={4}><Input title={i18n.iaeauOutputDir} value={filters.outputDir} onChange={v => onChangeFilters({ outputDir: v })} disabled={disabled} /></Grid>
                <Grid size={4}><Input title={i18n.iaeauChainCode} value={filters.chainCode} onChange={v => onChangeFilters({ chainCode: v })} disabled={disabled} /></Grid>
                <Grid size={4}><Input title={i18n.filter} value={filters.filter} onChange={v => onChangeFilters({ filter: v })} disabled={disabled} /></Grid>
                <Grid size={4}><Checkbox label={i18n.renameDoneErrorFic} onChange={v => onChangeFilters(v ? { renameProcessedFiles: true, dontProcessFilesInLogs: false } : { renameProcessedFiles: false })} disabled={disabled} checked={filters.renameProcessedFiles} /></Grid>
                <Grid size={4}><Checkbox label={i18n.dontProcessFilesInLogs} onChange={v => onChangeFilters(v ? { dontProcessFilesInLogs: true, renameProcessedFiles: false } : { dontProcessFilesInLogs: false })} disabled={disabled} checked={filters.dontProcessFilesInLogs} /></Grid>
                <Grid size={4}><Checkbox label={i18n.replayErrorFiles} onChange={v => onChangeFilters({ replayErrorFiles: v })} disabled={disabled} checked={filters.replayErrorFiles} /></Grid>
                <Grid size={4}><Input title={i18n.iaeauTimeout} value={filters.timeout || '60'} onChange={v => onChangeFilters({ timeout: v })} disabled={disabled} type='int' /></Grid>
                {isAquasysUser && filters.chainCode && (
                    <Grid size={4} display='flex' alignItems='center'>
                        <Button
                            icon='open_in_new'
                            title={i18n.iaeauChainAccess}
                            onClick={() => window.open(targetIAEauChainUrl, '_blank')}
                        />
                    </Grid>
                )}
            </Grid>
        </Grid>
    )
}

ProcessFileIAEauJob.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    filters: PropTypes.object,
    job: PropTypes.instanceOf(Job).isRequired,
    isEditMode: PropTypes.bool,
    onChangeFilters: PropTypes.func,
}

export default ProcessFileIAEauJob